<template>
  <div class="Alpha-Post-Cover">
    <template v-if="get_isPon">
      <img
        class="Alpha-Post-Cover__image"
        :src="pon_chat"
        alt="img"
        loading="lazy"
        :class="{ 'Alpha-Post-Cover__image--is-hidden': loadingPon }"
        @load="onLoad('Pon')"
        @error="onError('Pon')"
      />
      <SkeletItem class="Alpha-Post-Cover__skelet" :height="heightImg"  v-if="loadingPon" />
    </template>

    <template v-else-if="get_isCover">
      <img
        class="Alpha-Post-Cover__image"
        :src="get_cover"
        alt="img"
        loading="lazy"
        :class="{ 'Alpha-Post-Cover__image--is-hidden': loadingCover }"
        @load="onLoad('Cover')"
        @error="onError('Cover')"
      />
      <SkeletItem class="Alpha-Post-Cover__skelet" :height="heightImg" v-if="loadingCover" />
    </template>

    <template v-else-if="get_isUserAvatar">
      <img
        class="Alpha-Post-Cover__image"
        :src="get_userAvatar"
        alt="img"
        loading="lazy"
        :class="{ 'Alpha-Post-Cover__image--is-hidden': loadingAvatar }"
        @load="onLoad('Avatar')"
        @error="onError('Avatar')"
      />
      <SkeletItem class="Alpha-Post-Cover__skelet" :height="heightImg" v-if="loadingAvatar" />
    </template>

    <PostAudioButton :post="get_postData" v-else-if="get_isPodcast" />

    <div class="Alpha-Post-Cover__wrapper" v-else>
      <XIcon v-if="get_isX" />
      <AlphaIcon v-else />
    </div>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  import { POST_TYPES } from '@shared/constants/posts/postTypes.js';
  import { useScreenSize } from '@/Groups/Audioplayer/private/imports/screenSize';

  import XIcon from './icons/xIcon.vue';
  import AlphaIcon from './icons/AlphaIcon.vue';
  import PostAudioButton from '@/Groups/Audioplayer/public/modules/PostAudioButton/PostAudioButton.vue';
  import SkeletItem from '@shared/UI/Skeletons/SkeletItem/SkeletItem.vue';

  const props = defineProps(Props());
  const store = useStore();

  const { screenWidth } = useScreenSize();

  const heightImg = computed(() => screenWidth.value > 576 ? 79 : 48);

  const pon_chat = '/media/images/pon_chat.webp';

  const get_postData = computed(() => store.state.ContentSystem.Alpha.list[props.postId] || props.post);

  // Каналы и типы постов
  const get_isX = computed(() => get_postData.value.channels?.some(channel => channel.slug === 'обзор-x'));
  const get_isPon = computed(() => get_postData.value.channels?.some(channel => channel.slug === 'выжимка-pon'));
  const get_isPodcast = computed(() => get_postData.value.section_name === POST_TYPES.PODCAST);
  const get_isCover = computed(() => get_postData.value.images_list.length > 0 && !get_isX.value && !get_isPon.value);
  const get_isUserAvatar = computed(() => get_postData.value.section_name === POST_TYPES.OPINION && !get_isCover.value);
  const get_userAvatar = computed(() => get_postData.value.author.avatar);
  const get_cover = computed(() => get_postData.value.images_list[0]);

  // Состояние загрузки картинок
  const loadingPon = ref(true);
  const loadingCover = ref(true);
  const loadingAvatar = ref(true);

  const onLoad = (type) => {
    if (type === 'Pon') loadingPon.value = false;
    if (type === 'Cover') loadingCover.value = false;
    if (type === 'Avatar') loadingAvatar.value = false;
  };

  const onError = (type) => {
    if (type === 'Pon') loadingPon.value = false;
    if (type === 'Cover') loadingCover.value = false;
    if (type === 'Avatar') loadingAvatar.value = false;
  };
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>
